import { Button, Flex, Select, Typography } from "antd";
import { MarkDownEditorComponent } from "../../../../../components";

const categoryOptions = [];
for (let i = 10; i < 36; i++) {
  categoryOptions.push({
    value: i.toString(36) + i,
    label: i.toString(36) + i,
  });
}

export function CreateWorkshopView() {
  const onSelectCategory = (value) => {
    console.log(`Selected: ${value}`);
  };

  const questions = [
    {
      id: 1,
      name: "data_used",
      question:
        "¿Qué datos se utilizan en este proceso y de dónde provienen? (Bases de datos, archivos, APIs, sistemas internos, etc.)",
    },
    {
      id: 2,
      name: "data_access",
      question:
        "¿Cómo se accede actualmente a estos datos? (Conexiones directas, descargas manuales, servicios web, etc.)",
    },
    {
      id: 3,
      name: "data_storage",
      question:
        "¿Dónde se almacenan actualmente los resultados de este proceso? (Ejemplo: bases de datos, archivos, sistemas internos)",
    },
    {
      id: 4,
      name: "integrations",
      question:
        "¿El proceso implica la integración con otros sistemas o plataformas? Si es así, ¿cuáles son y cómo se comunican?",
    },
    {
      id: 5,
      name: "infrastructure",
      question:
        "¿Qué infraestructura tecnológica tienen actualmente? (Ejemplo: servidores propios, nube pública/privada, contenedores, etc.)",
    },
    {
      id: 6,
      name: "events",
      question:
        "¿Existen eventos que disparen acciones dentro del proceso? (Ejemplo: llegada de datos, aprobaciones, notificaciones)",
    },
    {
      id: 7,
      name: "rules_validations",
      question:
        "¿Hay reglas o validaciones específicas que deban cumplirse en cada paso del flujo?",
    },
    {
      id: 8,
      name: "error_handling",
      question: "¿Cómo se manejan los errores o excepciones actualmente?",
    },
    {
      id: 9,
      name: "frequency",
      question:
        "¿Con qué frecuencia ocurre este proceso o problema actualmente?",
    },
    {
      id: 10,
      name: "scalability",
      question:
        "¿Esperan que el volumen de datos o la cantidad de usuarios involucrados en este proceso aumente en el futuro?",
    },
    {
      id: 11,
      name: "metrics",
      question:
        "¿Cuáles son las métricas clave que usan actualmente para evaluar el rendimiento de este proceso?",
    },
    {
      id: 12,
      name: "monitoring",
      question:
        "¿Cómo se monitorean actualmente los procesos o el rendimiento de este flujo?",
    },
  ];
  return (
    <Flex vertical>
      <Typography.Title level={2}>Nuevo Taller</Typography.Title>
      <Typography.Text>
        Selecciona las categorías a las que pertenece el taller
      </Typography.Text>
      <br />

      <Typography.Title level={4}>Categoria del problema</Typography.Title>
      <Select
        mode="multiple"
        size={"large"}
        placeholder="Selecciona la categoría"
        defaultValue={["Ensamblaje Automotríz", "Moldeado de piezas"]}
        onChange={onSelectCategory}
        style={{
          minWidth: "50%",
          maxWidth: "100%",
        }}
        options={categoryOptions}
      />
      <Typography.Title level={4}>Descripción del problema</Typography.Title>
      <MarkDownEditorComponent
        placeHolder={"Descripción del problema"}
        onChange={() => {}}
      />

      <Typography.Title level={4}>
        Flujo de negocio detallado (Prompt)
      </Typography.Title>
      <MarkDownEditorComponent
        placeHolder={"Flujo de negocio detallado"}
        onChange={() => {}}
      />

      {questions.map((question) => (
        <div key={question.id}>
          <Typography.Title level={4}>{question.question}</Typography.Title>
          <MarkDownEditorComponent
            placeHolder={""}
            name={question.name}
            onChange={() => {}}
          />
        </div>
      ))}

      <Button type="primary">Guardar</Button>
    </Flex>
  );
}
